import { TestRunTopicMetaField } from '.';

export default class TestRunResulPreviewModel {
    packageId: string;
    topicId: string;
    blocks: TestRunTopicMetaField[];
}
